module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lLQxW"))).then(() => parcelRequire('1iHdE'));